import React from 'react';
import { TimetableEntry, UnmetPreference } from '../types';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Container,
} from '@mui/material';

interface TimetableProps {
  timetable: TimetableEntry[];
  unmetPreferences: UnmetPreference[];
}

const Timetable: React.FC<TimetableProps> = ({ timetable, unmetPreferences }) => {
  console.log('Rendering timetable with data:', { timetable, unmetPreferences });

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  const timeSlots = [
    '09:00-10:30',
    '10:45-12:15',
    '13:30-15:00',
    '15:15-16:45',
    '17:00-18:30',
    '18:45-20:15'
  ];

  const getCourseForSlot = (day: string, timeSlot: string) => {
    return timetable.find(
      (entry) => entry.day === day && entry.timeSlot === timeSlot
    );
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Generated Timetable
        </Typography>
        
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Time/Day</TableCell>
                {days.map((day) => (
                  <TableCell key={day} sx={{ fontWeight: 'bold' }}>
                    {day}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {timeSlots.map((timeSlot) => (
                <TableRow key={timeSlot}>
                  <TableCell sx={{ fontWeight: 'bold' }}>
                    {timeSlot}
                  </TableCell>
                  {days.map((day) => {
                    const course = getCourseForSlot(day, timeSlot);
                    return (
                      <TableCell key={`${day}-${timeSlot}`}>
                        {course ? (
                          <Box
                            sx={{
                              p: 1,
                              borderRadius: 1,
                              bgcolor: course.gotPreferredTime ? 'success.light' : 'warning.light',
                              color: 'text.primary',
                            }}
                          >
                            <Typography variant="subtitle2">
                              {course.courseName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Teacher: {course.teacherId}
                            </Typography>
                            {!course.gotPreferredTime && (
                              <Typography variant="caption" color="warning.dark">
                                Scheduled in alternative time slot
                              </Typography>
                            )}
                          </Box>
                        ) : (
                          <Typography variant="body2" color="text.disabled">
                            No class
                          </Typography>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {unmetPreferences && unmetPreferences.length > 0 && (
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Unmet Preferences
            </Typography>
            <Paper sx={{ p: 2, bgcolor: 'warning.light' }}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                The following courses could not be scheduled in their preferred time slots:
              </Typography>
              <Box component="ul" sx={{ pl: 2 }}>
                {unmetPreferences.map((pref) => (
                  <Box component="li" key={pref.courseId} sx={{ mb: 0.5 }}>
                    {pref.courseName} - Preferred: {pref.preferredDay} {pref.preferredTime}
                  </Box>
                ))}
              </Box>
            </Paper>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default Timetable; 